<template>
   <div>
     <PageBlocked />
   </div>
</template>

<style>

</style>
<script>
import PageBlocked from '@/components/PageBlocked.vue'
export default {
  name: 'BlockedPage',
  components: {
    PageBlocked
  }
}

</script>